/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneVideoInTextTeaser as ResolvedStandaloneVideoInTextTeaser } from 'base/components/standalone/VideoInTextTeaser';

export const VideoInTextTeaser: typeof ResolvedStandaloneVideoInTextTeaser = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneVideoInTextTeaser {...props} />
        </ErrorBoundary>
    );
});

export type VideoInTextTeaserProps = PropsFromComponent<typeof VideoInTextTeaser>;

/** @deprecated Use slot architecture instead */
export const VideoInTextTeaserWith = (extras: DynamicStandaloneExtras): typeof VideoInTextTeaser => {
    return function VideoInTextTeaser(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'VideoInTextTeaser');
        return <ResolvedStandaloneVideoInTextTeaser {...mergeProps({ options: { theme } }, props)} />;
    }
}